import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { toast } from "sonner";
import client from "@/lib/apiClient";
import { useLang } from "@/i18n";
import { useProperty } from "@/context/PropertyContext";
import { SectionHeader, Loader, Lu } from "@/components/shared";
import { Button } from "@/components/ui/button";

export default function Scenes() {
  const { t, lang } = useLang();
  const { selectedId } = useProperty();
  const [scenes, setScenes] = useState(null);

  useEffect(() => {
    if (!selectedId) return;
    setScenes(null);
    client.get(`/properties/${selectedId}/scenes`).then((r) => setScenes(r.data));
  }, [selectedId]);

  if (!scenes) return <Loader />;

  return (
    <div>
      <SectionHeader icon="sparkles" title={t("scenes")} subtitle={t("liveData")} />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {scenes.map((s, i) => (
          <motion.div key={s.key} data-testid={`scene-${s.key}`}
            initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }}
            className="md-card p-5 group">
            <div className="flex items-center justify-between mb-4">
              <span className="w-12 h-12 rounded-2xl md-gold-gradient flex items-center justify-center md-gold-glow">
                <Lu name={s.icon} className="w-6 h-6 text-primary-foreground" />
              </span>
              <span className="text-xs px-2.5 py-1 rounded-full bg-foreground/5 text-muted-foreground font-mono">{s.active_rooms} {t("activeRooms")}</span>
            </div>
            <h3 className="text-lg font-bold text-foreground">{s[lang === "ar" ? "name_ar" : "name_en"]}</h3>
            <p className="text-xs text-muted-foreground/70 mt-1">{s.key}</p>
            <Button data-testid={`apply-${s.key}`} onClick={() => toast.success(`${t("applyAll")}: ${s[lang === "ar" ? "name_ar" : "name_en"]}`)}
              className="w-full mt-4 bg-foreground/5 hover:bg-primary/15 border border-border hover:border-primary/30 text-foreground/80">
              <Lu name="play" className="w-4 h-4 ltr:mr-2 rtl:ml-2" />{t("applyAll")}
            </Button>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
